var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreterthen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 17,
    viewBox: "0 0 9 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.219761 1.28021C0.150078 1.21052 0.0948039 1.1278 0.057092 1.03675C0.01938 0.94571 -3.12328e-05 0.848128 -3.12328e-05 0.749582C-3.12328e-05 0.651036 0.01938 0.553455 0.057092 0.46241C0.0948039 0.371365 0.150078 0.28864 0.219761 0.218957C0.289444 0.149274 0.372169 0.0939998 0.463214 0.0562878C0.554259 0.0185758 0.65184 -0.000835419 0.750386 -0.000835419C0.848933 -0.000835419 0.946514 0.0185758 1.03756 0.0562878C1.1286 0.0939998 1.21133 0.149274 1.28101 0.218957L8.78101 7.71896C8.85074 7.78861 8.90606 7.87133 8.94381 7.96238C8.98155 8.05343 9.00098 8.15102 9.00098 8.24958C9.00098 8.34814 8.98155 8.44574 8.94381 8.53679C8.90606 8.62784 8.85074 8.71055 8.78101 8.78021L1.28101 16.2802C1.14028 16.4209 0.949409 16.5 0.750386 16.5C0.551364 16.5 0.360492 16.4209 0.219761 16.2802C0.0790306 16.1395 -3.12289e-05 15.9486 -3.12328e-05 15.7496C-3.12368e-05 15.5506 0.0790306 15.3597 0.219761 15.219L7.19007 8.24958L0.219761 1.28021Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreterthen);
export default __webpack_public_path__ + "static/media/greterthen.dcb0bb948a7d75e9a704ad1b35f2598c.svg";
export { ForwardRef as ReactComponent };